module.exports = __webpack_public_path__ + "static/media/parthiv.9ffd9375.png";